import { h, Component } from 'preact';

export default class ChatFrame extends Component {
    shouldComponentUpdate() {
        return false;
    }

    render({host, iFrameSrc, conf}, {}) {
        let dynamicConf = window.intergramOnOpen || {};
        let encodedConf = encodeURIComponent(JSON.stringify({...conf, ...dynamicConf}));

        return (
            <iframe
                src={iFrameSrc + '?v=20260646&id=backend&host=' + host + '&conf=' + encodedConf}
                width="100%"
                height="100%"
                frameborder="0"
                style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    border: '0'
                }}>
            </iframe>
        );
    }
}


// WEBPACK FOOTER //
// ./src/widget/chat-frame.js